export default __webpack_public_path__ + "media/images/features/saga/map_marker-457a8eccbafb4881a8f7428d00019c5e.png";